function setSectionUrl(sectionName) {
  const urlParams = (new URL(document.location)).searchParams.toString();
  window.history.replaceState(null, '', `${document.location.pathname}${!!urlParams ? '?' : ''}${urlParams}#${sectionName}`);
}

function gotoSection(target, setUrl = true){
  const name = target.getAttribute('data-section-name') ?? 'about';

  const currentClassName = ['border-primary-500', 'text-primary-600'];
  const defaultClassName = ['border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700'];

  const sectionLinks = document.getElementsByClassName("goto-section-link");

  Array.from(sectionLinks).forEach((button) => {
    button.classList.remove(...currentClassName);
    button.classList.add(...defaultClassName);
  });
  target.classList.remove(...defaultClassName);
  target.classList.add(...currentClassName);

  switch(name){
    case "about":
      return gotoAboutSection(setUrl);
    case "open-positions":
      return gotoOpenPositions(setUrl);
    case "photos":
      return gotoPhotoSection(setUrl);
    case "under-the-hood":
      return gotoUnderTheHoodSection(setUrl);
    case "videos":
      return gotoVideoSection(setUrl);
    default:
      return gotoAboutSection(setUrl);
  }
}

function gotoAboutSection(setUrl = false){
  if (setUrl) setSectionUrl('about');

  // show
  document.getElementById("get-in-touch-section").classList.remove("mobile:hidden")
  document.getElementById("shop-groups-section")?.classList.remove("mobile:hidden")
  document.getElementById("about-us-section").classList.remove("mobile:hidden")
  document.getElementById("about-us-section_mobile").classList.remove("mobile:hidden")

  // hide
  document.getElementById("open-positions-section")?.classList.add("mobile:hidden")
  document.getElementById("under-the-hood-section").classList.add("mobile:hidden")
  document.getElementById("photos-section").classList.add("mobile:hidden")
  document.getElementById("shop-talk-section").classList.add("mobile:hidden")
}

function gotoOpenPositions(setUrl = false){
  if (setUrl) setSectionUrl('open-positions');

  // hide
  document.getElementById("get-in-touch-section").classList.add("mobile:hidden")
  document.getElementById("shop-groups-section")?.classList.add("mobile:hidden")
  document.getElementById("about-us-section").classList.add("mobile:hidden")
  document.getElementById("about-us-section_mobile").classList.add("mobile:hidden")
  document.getElementById("under-the-hood-section").classList.add("mobile:hidden")
  document.getElementById("photos-section").classList.add("mobile:hidden")
  document.getElementById("shop-talk-section").classList.add("mobile:hidden")

  // show
  document.getElementById("open-positions-section")?.classList.remove("mobile:hidden")
}

function gotoUnderTheHoodSection(setUrl = false){
  if (setUrl) setSectionUrl('under-the-hood');

  // hide
  document.getElementById("get-in-touch-section").classList.add("mobile:hidden")
  document.getElementById("shop-groups-section")?.classList.add("mobile:hidden")
  document.getElementById("about-us-section").classList.add("mobile:hidden")
  document.getElementById("about-us-section_mobile").classList.add("mobile:hidden")
  document.getElementById("open-positions-section")?.classList.add("mobile:hidden")
  document.getElementById("photos-section").classList.add("mobile:hidden")
  document.getElementById("shop-talk-section").classList.add("mobile:hidden")

  // show
  document.getElementById("under-the-hood-section").classList.remove("mobile:hidden")
}

function gotoPhotoSection(setUrl = false){
  if (setUrl) setSectionUrl('photos');

  // hide
  document.getElementById("get-in-touch-section").classList.add("mobile:hidden")
  document.getElementById("shop-groups-section")?.classList.add("mobile:hidden")
  document.getElementById("about-us-section").classList.add("mobile:hidden")
  document.getElementById("about-us-section_mobile").classList.add("mobile:hidden")
  document.getElementById("open-positions-section")?.classList.add("mobile:hidden")
  document.getElementById("under-the-hood-section").classList.add("mobile:hidden")
  document.getElementById("shop-talk-section").classList.add("mobile:hidden")

  // show
  document.getElementById("photos-section").classList.remove("mobile:hidden")
}

function gotoVideoSection(setUrl = false){
  if (setUrl) setSectionUrl('videos');

  // hide
  document.getElementById("get-in-touch-section").classList.add("mobile:hidden")
  document.getElementById("shop-groups-section")?.classList.add("mobile:hidden")
  document.getElementById("about-us-section").classList.add("mobile:hidden")
  document.getElementById("about-us-section_mobile").classList.add("mobile:hidden")
  document.getElementById("open-positions-section")?.classList.add("mobile:hidden")
  document.getElementById("under-the-hood-section").classList.add("mobile:hidden")
  document.getElementById("photos-section").classList.add("mobile:hidden")

  // show
  document.getElementById("shop-talk-section").classList.remove("mobile:hidden")
}

document.addEventListener('DOMContentLoaded', () => {
  const sectionLinks = document.getElementsByClassName("goto-section-link")
  Array.from(sectionLinks).forEach(
    (link) => link.addEventListener('click', (el)=> gotoSection(el.target))
  );

  const hash = window.location.hash.slice(1);
  const gotoToggle = document.querySelector(`.goto-section-link[data-section-name='${hash}']`);
  if (gotoToggle) {
    gotoSection(gotoToggle, false);
  } else {
    const gotoToggleDefault = document.querySelector(".goto-section-link[data-section-name='about']");
    if (gotoToggleDefault) { gotoSection(gotoToggleDefault, false) }
  }
})
